class AccordionPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      height: 0
    };
  }

  componentDidMount() {
    window.setTimeout(() => {
      const el = ReactDOM.findDOMNode(this);
      const height = el.querySelector('.panel__inner').scrollHeight;
      this.setState({height});
    }, 350);
  }

  componentDidUpdate(prevProps, prevState) {
    const el = ReactDOM.findDOMNode(this);
    const height = el.querySelector('.panel__inner').scrollHeight;
    if (height !== prevState.height) {
      this.setState({height});
    }
  }

  render() {
    const {label, details, children, activeTab, index, activateTab} = this.props;
    const {height} = this.state;
    const isActive = activeTab === index;
    const innerStyle = {
      maxHeight: `${isActive ? height : 0}px`
    };
    return (
      <div className="panel"
           role="tabpanel"
           aria-expanded={isActive}>
        <button className="panel__label"
                type="button"
                role="tab"
                onClick={activateTab}>
          {label} <span className="details sf-pri-color">{details}</span>
        </button>
        <div className="panel__inner"
             style={innerStyle}
             aria-hidden={!isActive}>
          <div className='panel__content'>
            {children}
          </div>
        </div>
      </div>
    );
  }
}

class Accordion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0  // SET DEFAULT ACTIVE TAB
    };
    window.cp.active_tab = this.state.activeTab;
    this.activateTab = this.activateTab.bind(this);
  }

  activateTab(index) {
    // set to -1 if same tab clicked as the current active tab
    let new_tab = this.state.activeTab === index ? -1 : index;
    this.setState({
      activeTab: new_tab
    });
    window.cp.active_tab = new_tab;
//        setInteriorViewMode(new_tab === 3);
    this.props.onChange(index);
  }

  render() {
    return (
      <div className='accordion' role='tablist'>
        {this.props.children.map((child, index) => (
          <AccordionPanel
            label={child.props.label}
            details={child.props.details}
            key={index}
            activeTab={this.state.activeTab}
            index={index}
            activateTab={this.activateTab.bind(null, index)}
          >
            {child.props.children}
          </AccordionPanel>
        ))}
      </div>
    );
  }
}


class RadioGroup extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
    this.handleCustomValueChange = this.handleCustomValueChange.bind(this);
  }

  handleChange(e) {
    this.props.onChange(e.target.value);
  }

  handleCustomValueChange(e) {
    window.cp.current_state.materials[window.cp.material_group_lookup[this.props.prefix]].custom_value = e.target.value;
  }

  render() {
    return (
      <div className="thumb-selector">
        <div className="checkbox-group">
          <div className="label">{this.props.label}</div>
          <div className="current-selection">
            {this.props.options.find(opt => {
              return this.props.value == opt.value;
            }).label}
          </div>
          {
            this.props.options.map(opt => {
              let input_id = this.props.prefix + '_' + opt.value;
              let is_checked = this.props.value == opt.value;
              let custom_color_value = '';
              if (opt.allow_custom_value && is_checked) {
                let color_value_obj = window.cp.current_state.materials[window.cp.material_group_lookup[this.props.prefix]];
                if (color_value_obj.hasOwnProperty('custom_value')) {
                  custom_color_value = color_value_obj.custom_value;
                }
              }
              return (
                <React.Fragment key={opt.color_group + '_' + opt.value}>
                  <input id={input_id}
                         className="input-hidden"
                         name={this.props.groupName}
                         onChange={this.handleChange}
                         value={opt.value}
                         checked={is_checked}
                         type="radio"/>
                  <label htmlFor={input_id} className="form-label">
                    <img src={COLOR_THUMB_URL + opt.icon} alt=""/>
                    <div className="option-label">
                      {opt.label}
                    </div>
                    {opt.allow_custom_value && is_checked && <div className="option-custom-input">
                      <input id={input_id + '_custom_value'}
                             type="text"
                             name={this.props.groupName + '_custom'}
                             onChange={this.handleCustomValueChange}
                             defaultValue={custom_color_value}/>
                    </div>}
                  </label>
                </React.Fragment>
              );
            })
          }
        </div>
      </div>
    );
  }
}


// SIZE SELECTOR
class StructureSizeSelector extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(val, actionMeta) {
    if (actionMeta.action == 'select-option') {
      doSizeChange(val.value);
    }
    this.props.onChange(val);
  }

  render() {
    const base_sizes = window.cp.settings.base_sizes;
    const select_options = [];
    for (let o in this.props.options) {
      // if this size has been disabled, and is not the current selection, skip
      if (this.props.options[o].disabled && this.props.sel_size_id !== o) {
        continue;
      }
      select_options.push({value: o, label: base_sizes[o].label});
    }
    const valueFromId = (select_options, sel_size_id) => select_options.find(opt => opt.value === sel_size_id);
    return (
      <Select
        options={select_options}
        value={valueFromId(select_options, this.props.sel_size_id)}
        onChange={this.handleChange}
        menuPortalTarget={document.body}
      />
    );
  }
}


// HEIGHT SELECTOR
class StructureHeightSelector extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(val, actionMeta) {
    if (actionMeta.action == 'select-option') {
      doHeightChange(val.value);
    }
    this.props.onChange(val);
  }

  render() {
    const base_heights = window.cp.settings.base_heights;
    const model_heights = window.cp.settings.models[window.cp.current_state.model.model_id].heights;
    const select_options = [];
    for (let o in this.props.options) {
      let h = model_heights[o];
      // if this height has been discontinued, and is not the current selection, skip
      if (h.discontinued && this.props.sel_height_id !== o) {
        continue;
      }
      let bh = base_heights[o];
      let enabled = (!h.hasOwnProperty('enabled') || h.enabled);
      let label = bh.label;
      if (h.hasOwnProperty('item_price') && h.item_price) {
        label += formatPrice(h.item_price, false, ' [', ']', false);
      }
      select_options.push({value: o, label: label, enable: enabled});
    }
    const valueFromId = (select_options, sel_height_id) => select_options.find(opt => opt.value === sel_height_id);
    return (
      <Select
        options={select_options}
        value={valueFromId(select_options, this.props.sel_height_id)}
        onChange={this.handleChange}
        menuPortalTarget={document.body}
        isOptionDisabled={(o) => !o.enable}
      />
    );
  }
}


// COLOR SELECTOR
class ColorSelector extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
    this.handleCustomValueChange = this.handleCustomValueChange.bind(this);
  }

  handleChange(val) {
    doColorChange(cp.material_group_lookup[this.props.target_name], val, this.props.parent_opt_group_id);
    this.props.onChange(val);
  }

  handleCustomValueChange(e) {
    window.cp.current_state.materials[window.cp.material_group_lookup[this.props.target_name]].custom_value = e.target.value;
  }

  render() {
    const color_group = window.cp.settings.colors[this.props.color_group_id];
    const select_options = [];
    for (let color_id in color_group) {
      const color = color_group[color_id];
      // we don't always have 'visible' property set on each color. We should consider missing property as true "visible".
      if ((!color.hasOwnProperty("visible") || color.visible) && (!color.disabled || this.props.sel_color_id == color_id)) {
        // adding in the price data if found
        let label = color.label;
        if (color.hasOwnProperty('item_price') && color.item_price) {
          label += formatPrice(color.item_price, false, ' [', ']', false);
        }
        select_options.push({
          value: color_id,
          label: label,
          color_group: this.props.color_group_id,
          icon: color.icon,
          allow_custom_value: color.allow_custom_value,
          discontinued: color.disabled,
          unavailable: color.unavailable,
        });
      }
    }
    // not going to render if only less than 2 choices
    if (select_options.length < 2) {
      return null;
    }

    // if this is a material selector with a parent option, let's add a class to help theme that
    let is_child = false;
    let wrapper_class = "";
    if (this.props.parent_opt_group_id) {
      is_child = true;
      wrapper_class = "sub-color-wrap";
    }

    if (window.cp.settings.company.color_selector_style === 'list') {
      return (
        <div className={wrapper_class}>{is_child ? <div className="drop-arrow">↳</div> : ""}<ColorPickerList
          selector_class_name={this.props.selector_class_name}
          label={this.props.label}
          onChange={this.handleChange}
          on_custom_value_change={this.handleCustomValueChange}
          options={select_options}
          target_name={this.props.target_name}
          color_group_id={this.props.color_group_id}
          sel_color_id={this.props.sel_color_id}
        /></div>
      );
    } else {
      return (
        <div className={wrapper_class}>{is_child ? <div className="drop-arrow">↳</div> : ""}<ColorPickerRadio
          label={this.props.label}
          onChange={this.handleChange}
          on_custom_value_change={this.handleCustomValueChange}
          options={select_options}
          target_name={this.props.target_name}
          color_group_id={this.props.color_group_id}
          sel_color_id={this.props.sel_color_id}
        /></div>
      );
    }
  }
}


// Color Picker RADIO that uses radio button format (more like a grid of buttons)
class ColorPickerRadio extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.props.onChange(e.target.value);
  }

  render() {
    const label = this.props.options.find(opt => {
      return this.props.sel_color_id == opt.value;
    }).label;

    let select_options = this.props.options.map(opt => {
      let input_id = this.props.target_name + '_' + opt.value;
      let is_checked = this.props.sel_color_id == opt.value;
      let custom_color_value = '';
      if (opt.allow_custom_value && is_checked) {
        let color_value_obj = window.cp.current_state.materials[window.cp.material_group_lookup[this.props.target_name]];
        if (color_value_obj.hasOwnProperty('custom_value')) {
          custom_color_value = color_value_obj.custom_value;
        }
      }
      return (
        <React.Fragment key={opt.color_group + '_' + opt.value}>
          <input id={input_id}
                 className="input-hidden"
                 name={this.props.target_name}
                 onChange={this.handleChange}
                 value={opt.value}
                 checked={is_checked}
                 type="radio"/>
          <label htmlFor={input_id} className="form-label">
            <img src={COLOR_THUMB_URL + opt.icon} alt=""/>
            <div className="option-label">
              {opt.label}
            </div>
            {opt.allow_custom_value && is_checked && <div className="option-custom-input">
              <input id={input_id + '_custom_value'}
                     type="text"
                     name={this.props.target_name + '_custom'}
                     onChange={this.props.on_custom_value_change}
                     defaultValue={custom_color_value}/>
            </div>}
          </label>
        </React.Fragment>
      );
    });

    return (
      <div className="color-selector">
        <div className="checkbox-group">
          <div className="label">{this.props.label}</div>
          <div className="current-selection">{label}</div>
          {select_options}
        </div>
      </div>
    );
  }
}


// Color Picker LIST that uses a dropdown button format (like a dropdown list)
class ColorPickerList extends React.Component {
  createColorList() {
    const opts = this.props.options;
    return opts.map(opt => {
      return (
        <ColorDropdownButton
          key={opt.value}
          label={opt.label}
          icon={opt.icon}
          target_group={this.props.target_group}
          target_color={opt.value}
          sel_color_id={this.props.sel_color_id}
          discontinued={opt.discontinued}
          unavailable={opt.unavailable}
          onClick={this.props.onChange}
        />
      );
    });
  }

  render() {
    // lookup the selected color from the color settings, need to use the color group to find the color
    const valueFromId = (select_options, sel_mat_id) => select_options.find(opt => opt.value === sel_mat_id);
    const sel_color = valueFromId(this.props.options, this.props.sel_color_id);

    // figure out if we need to show the custom color field.
    let custom_color_value = '';
    if (sel_color.allow_custom_value) {
      let color_value_obj = window.cp.current_state.materials[window.cp.material_group_lookup[this.props.target_name]];
      if (color_value_obj.hasOwnProperty('custom_value')) {
        custom_color_value = color_value_obj.custom_value;
      }
    }
    // make the list of all the color dropdown buttons
    const color_list = this.createColorList();

    return (
      <React.Fragment>
        {this.props.label && <div><label>{this.props.label}</label></div>}
        <div className={"btn-group color-selector " + this.props.selector_class_name}>
          <button
            type="button"
            className={"btn btn-secondary dropdown-toggle"}
            data-toggle="dropdown"
            data-boundary="viewport"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <img src={COLOR_THUMB_URL + sel_color.icon} width="25px" height="25px" alt=""/>
            {sel_color.label}
          </button>
          <div className="dropdown-menu">
            {color_list}
          </div>

          {sel_color.allow_custom_value && <div className="option-custom-input">
            <input id={this.props.target_name + '_custom_value'}
                   type="text"
                   name={this.props.target_name + '_custom'}
                   onChange={this.props.on_custom_value_change}
                   defaultValue={custom_color_value}/>
          </div>}
        </div>
      </React.Fragment>
    );
  }
}


class ColorDropdownButton extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.props.onClick(this.props.target_color);
  }

  render() {
    return (
      <div>
        <button
          type="button"
          className={"btn btn-secondary" + (this.props.sel_color_id == this.props.target_color ? ' active' : '')}
          onClick={this.onClick}
          disabled={this.props.hasOwnProperty('unavailable') && this.props.unavailable ? 'disabled' : ''}
        >
          <img src={COLOR_THUMB_URL + this.props.icon} width="25px" height="25px" alt=""/>&nbsp;{this.props.label}
          {this.props.discontinued && <span className="discontinued"> (discontinued)</span>}
          {this.props.hasOwnProperty('unavailable') && this.props.unavailable &&
            <span className="discontinued"> ({this.props.unavailable})</span>}
        </button>
      </div>
    );
  }
}


// MATERIAL SELECTOR
class MaterialSelector extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(val, actionMeta) {
    if (actionMeta.action == 'select-option') {
      doMaterialChange(this.props.mat_group_id, val.value, this.props.parent_opt_group_id);
    }
    this.props.onChange(val);
  }

  render() {
    let opts = this.props.options;
    if (!opts || opts.length < 2) {
      return null;
    }
    // if this is a material selector with a parent option, let's add a class to help theme that
    let is_child = false;
    let wrapper_class = "";
    if (this.props.parent_opt_group_id) {
      is_child = true;
      wrapper_class = "sub-material-wrap";
    }

    let select_options = [];
    for (let o in opts) {
      let mat_id = opts[o];
      let mat = window.cp.settings.materials[mat_id];
      let enabled = true;
      if (mat.hasOwnProperty('enabled') && !mat.enabled) {
        enabled = false;
      }
      // if hidden, just leave out of this list
      if (mat.hasOwnProperty('visible') && !mat.visible) {
        continue;
      }
      let label = mat.label;
      if (mat.hasOwnProperty('item_price') && mat.item_price) {
        label += formatPrice(mat.item_price, false, ' [', ']', false);
      }
      select_options.push({value: mat_id, label: label, weight: mat.weight, enable: enabled});
    }
    select_options.sort((a, b) => (a.weight - b.weight));

    const valueFromId = (select_options, sel_mat_id) => select_options.find(opt => opt.value === sel_mat_id);
    return (
      <div className={wrapper_class}>{is_child ? <div className="drop-arrow">↳</div> : ""}<Select
        className={this.props.selector_class_name}
        options={select_options}
        value={valueFromId(select_options, this.props.sel_mat_id)}
        onChange={this.handleChange}
        menuPortalTarget={document.body}
        isOptionDisabled={(o) => !o.enable}
      /></div>
    );
  }
}


// BOOTSTRAP BUTTON GROUP (justified)
class ButtonGroup extends React.Component {
  render() {
    const wrapclasses = (this.props.wrapClasses ? this.props.wrapClasses + ' ' : '');
    return (
      <div className={wrapclasses + "btn-group d-flex w-100"} role="group">
        {this.props.children}
      </div>
    );
  }
}


// ACTION BUTTON
// the action prop should be 'process' or 'none'
// 'process' will be an order submit button and they will disable when any one of them are clicked
// 'none' will rerender the 3d view and will not disable when clicked
class ActionButton extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    // can maybe check the active_action_button from the props, didn't try
    if (this.props.action == 'process' && window.cp.active_action_button == null) {
      e.preventDefault();
      // call the callback to do the required action for the button, pass the DOM button along for reference
      this.props.callback(this);
    }
    if (this.props.action == 'none') {
      this.props.callback(this);
      // renders the scene if 3d
      renderSingleFrame();
    }
  }

  render() {
    const extra_classes = (this.props.extraClasses ? ' ' + this.props.extraClasses : '');
    let is_disabled = (this.props.action == 'process' ? (window.cp.active_action_button != null) : false);
    // start animation loading spinner, only if the action is 'process'
    // if (this.props.action == 'process' && window.cp.active_action_button == this) {
    //     let spinner = <span><span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> Processing</span>;
    // }
    return (
      <button
        type="button"
        className={"btn w-100 border border-secondary btn-lg" + extra_classes}
        role="button"
        onClick={this.onClick}
        disabled={(is_disabled ? true : undefined)}
      >
        {this.props.label}
      </button>
    );
  }
}


// STYLE BUTTON (has image and is used with the StructureStyleSelector)
// target is the name of the model, and this is also used to find the thumbnail image
class StyleButton extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.props.onClick(this.props.target_model, this.props.target_group);
  }

  render() {
    const models = window.cp.settings.models;

    return (
      <button
        type="button"
        className={"btn btn-secondary" + (this.props.sel_model_id == this.props.target_model ? ' active' : '')}
        onClick={this.onClick}
      >
        <img src={MODEL_THUMB_URL + models[this.props.target_model].icon} alt=""/>
        <div className="icon-label">{this.props.label}</div>
      </button>
    );
  }
}

// STYLE DROPDOWN Button (has image and is used with the StyleGroup dropdowns)
// target is the name of the model, and this is also used to find the thumbnail image
class StyleDropdownButton extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.props.onClick(this.props.target_model, this.props.target_group);
  }

  render() {
    const models = window.cp.settings.models;

    return (
      <div>
        <button
          type="button"
          className={"btn btn-secondary" + (this.props.sel_model_id == this.props.target_model ? ' active' : '')}
          onClick={this.onClick}
        >
          <img src={MODEL_THUMB_URL + models[this.props.target_model].icon} alt=""/>&nbsp;{this.props.label}
        </button>
      </div>
    );
  }
}


// STYLE GROUP (is used with the StructureStyleSelector)
class StyleGroup extends React.Component {
  createModelList() {
    const models = window.cp.settings.models;
    const opts = this.props.options;
    if (opts.length == 1) {
      const id = opts[0];
      // don't show if role not allowed for this model
      if (!cp_structures_user_has_role(models[id].allowed_roles)) {
        return null;
      }
      return (
        <StyleButton
          key={id}
          label={models[id].label}
          target_group={this.props.target_group}
          target_model={id}
          sel_model_id={this.props.sel_model_id}
          onClick={this.props.onChange}
        />
      );
    }

    return opts.map(id => {
      return (
        <StyleDropdownButton
          key={id}
          label={models[id].label}
          target_group={this.props.target_group}
          target_model={id}
          sel_model_id={this.props.sel_model_id}
          onClick={this.props.onChange}
        />
      );
    });
  }

  render() {
    let isMultipleModelGroup = (this.props.options.length > 1);
    const model_list = this.createModelList();
    if (!model_list) {
      return null;
    }
    const model_groups = window.cp.settings.model_groups;
    let icon_file = model_groups[this.props.target_group].icon;
    if (icon_file) {
      icon_file = MODEL_GROUP_THUMB_URL + icon_file;
    } else {
      // if this is a multiple group (if single, then the group icon isn't used anyway.)
      if (isMultipleModelGroup) {
        // use the currently selected model's icon
        let target_model_id;
        // if this is the currently selected group
        if (this.props.sel_group_id == this.props.target_group && this.props.options.includes(this.props.sel_model_id)) {
          target_model_id = this.props.sel_model_id;
        } else {
          // use the icon from the first model in the list
          target_model_id = this.props.options[0];
        }
        icon_file = MODEL_THUMB_URL + window.cp.settings.models[target_model_id].icon;
      }
    }
    return (
      <div className="btn-group">
        {isMultipleModelGroup ? (
          <React.Fragment>
            <button
              type="button"
              className={"btn btn-secondary dropdown-toggle" + (this.props.sel_group_id == this.props.target_group ? ' active' : "")}
              data-toggle="dropdown"
              data-boundary="viewport"
              aria-haspopup="true"
              aria-expanded="false"
            >
              <img src={icon_file} alt=""/>
              {this.props.label}
            </button>
            <div className="dropdown-menu">
              {model_list}
            </div>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {model_list}
          </React.Fragment>
        )}
      </div>
    );
  }
}


// STYLE SELECTOR
class StructureStyleSelector extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(target_model, target_group) {
    // change the structure model
    doChangeModel(target_model, target_group);
  }

  createModelGroups() {
    const group_options = this.props.group_options;
    let group_elements = [];
    for (let group_id in group_options) {
      let group = group_options[group_id];
      group_elements.push(
        <StyleGroup
          key={group_id}
          label={group.label}
          onChange={this.handleChange}
          options={group.models}
          sel_model_id={this.props.sel_model_id}
          sel_group_id={this.props.sel_group_id}
          target_group={group_id}
        />
      );
    }
    return group_elements;
  }

  render() {
    const model_groups = this.createModelGroups();
    const model_name = this.props.options[this.props.sel_model_id].label;

    return (
      <div className="style-selector thumb-dropdown">
        <div className="label">{this.props.label + ' (' + model_name + ')'}</div>
        <div>
          {model_groups}
        </div>
        <div className="clearfix"></div>
      </div>
    );
  }
}


// VIS OPTIONS BUTTON (has image and is used with the VisOptionGroup)
// target is the name of the option, and this is also used to find the thumbnail image
class VisOptionsButton extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.props.onClick(this.props.target);
  }

  render() {
    const options = window.cp.settings.options;
    const opt_details = options[this.props.target];

    let suffix = (opt_details.item_price_suffix ? opt_details.item_price_suffix : '');
    let price = formatPrice(opt_details.item_price, false, ' [', suffix + ']', false);
    return (
      <button
        type="button"
        className="btn btn-secondary vis-opt-button"
        onClick={this.onClick}
        disabled={this.props.group_disabled}
      >
        <img src={OPTION_THUMB_URL + opt_details.icon} alt=""/>
        <div className="icon-label">{this.props.label} <span className="price">{price}</span></div>
      </button>
    );
  }
}

// VIS OPTIONS DROPDOWN Button (has image and is used with the StyleGroup dropdowns)
// target is the name of the model, and this is also used to find the thumbnail image
class VisOptionsDropdownButton extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.onClick = this.onClick.bind(this);
  }

  onClick(e) {
    e.preventDefault();
    this.props.onClick(this.props.target);
  }

  render() {
    const options = window.cp.settings.options;
    const opt = options[this.props.target];
    let suffix = (opt.item_price_suffix ? opt.item_price_suffix : '');
    let price = formatPrice(opt.item_price, false, ' [', suffix + ']', false);
    // controls if this option is disabled or hidden
    let disabled = !opt.enabled;
    let vis_class = (opt.visible ? 'visible' : 'hidden');
    let icon_output = null;
    if (opt.icon) {
      icon_output = <img src={OPTION_THUMB_URL + opt.icon} alt=""/>;
    }
    return (
      <div className={vis_class}>
        <button
          type="button"
          className="btn btn-secondary"
          onClick={this.onClick}
          disabled={disabled}
        >
          {icon_output}
          &nbsp;{this.props.label} <span className="price">{price}</span>
        </button>
      </div>
    );
  }
}


// VIS OPTIONS GROUP (is used with the VisOptionsMenu)
class VisOptionsGroup extends React.Component {
  createOptionsList(disabled) {
    const option_details = window.cp.settings.options;
    const opts = this.props.options;

    let mapped_opts = [];
    let i = 0;
    for (let id of opts) {
      const opt = option_details[id];
      // skip discontinued or hidden options (this will allow the group to disappear if not options are shown)
      if (opt.discontinued || !opt.visible) {
        continue;
      }
      opt.id = id;
      mapped_opts[i++] = opt;
    }
    // don't output since no options are valid
    if (!mapped_opts.length) {
      return null;
    }
    // output a vis opt button since only 1 option is valid
    if (mapped_opts.length == 1) {
      const opt = mapped_opts[0];
      return [(
        <VisOptionsButton
          key={opt.id}
          label={opt.label}
          target={opt.id}
          onClick={this.props.onChange}
          group_disabled={disabled}
        />
      )];
    }
    // must be more than 1 valid option
    return mapped_opts.map(opt => {
      return (
        <VisOptionsDropdownButton
          key={opt.id}
          label={opt.label}
          target={opt.id}
          onClick={this.props.onChange}
        />
      );
    });
  }

  render() {
    const option_groups = window.cp.settings.option_groups;
    const opt_group = option_groups[this.props.target_group];
    // controls if this option is disabled or hidden
    let disabled = !opt_group.enabled;
    let vis_class = (opt_group.visible ? 'visible' : 'hidden');

    const options_list = this.createOptionsList(disabled);
    // no options returned, so just don't render this group
    if (!options_list || !options_list.length) {
      return null;
    }
    let isMultipleOptionGroup = (options_list.length > 1);

    return (
      <div className={vis_class}>
        {isMultipleOptionGroup ? (
          <div className="btn-group">
            <button
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              data-boundary="viewport"
              aria-haspopup="true"
              aria-expanded="false"
              disabled={disabled}
            >
              <img src={OPTION_GROUP_THUMB_URL + opt_group.icon} alt=""/>
              {this.props.label}
            </button>
            <div className="dropdown-menu">
              {options_list}
            </div>
          </div>
        ) : (
          <div className="btn-group">
            {options_list}
          </div>
        )}
      </div>
    );
  }
}


// VIS OPTIONS MENU
class VisOptionsMenu extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(target) {
    doAddNewOption(target);
    // renders the scene if 3d
    renderSingleFrame();
  }

  createOptionGroups() {
    const option_groups = this.props.option_groups;
    let group_elements = [];
    for (let i in cp.opt_groups_by_weight) {
      let group_id = cp.opt_groups_by_weight[i].id;
      let group = option_groups[group_id];
      // type is 'placer' and category is 'exterior' taxonomy ids
      if (group.type === "n6" && group.category == this.props.category) {
        group_elements.push(
          <VisOptionsGroup
            key={group_id}
            label={group.label}
            onChange={this.handleChange}
            options={group.options}
            target_group={group_id}
          />
        );
      }
    }
    return group_elements;
  }

  render() {
    const option_groups = this.createOptionGroups();
    return (
      <div className="option-selector thumb-dropdown">
        <div className="label">{this.props.label}</div>
        <div>
          {option_groups}
        </div>
        <div className="clearfix"></div>
      </div>
    );
  }
}


class NonVisOptionPriceOverride extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.state = {
      // default to open if there is still an override value, which will happen if the user hasn't clicked 'cancel', but did uncheck the option
      open: (this.props.price_override_val && this.props.price_override_val !== null),
    };
  }

  handleChange(val) {
    this.props.onChange(val.target.value);
  }

  handleOpen(e) {
    this.setState({open: true});
  }

  handleClose(e) {
    // set back to null so no override.
    this.props.onChange(null);
    this.setState({open: false});
  }

  render() {
    if (this.state.open) {
      // labels for the price value field based on the price method
      let opt_details = window.cp.settings.options[this.props.opt_id];
      let method = null;
      if (window.cp.price_calc_methods_lookup.hasOwnProperty(opt_details.price_calc)) {
        method = window.cp.price_calc_methods_lookup[opt_details.price_calc];
      }
      return (
        <>
          <div>
            <label>{"\u00a0↳"} Override {method.price_value_label}&nbsp;</label>
            <input
              type="number"
              step="0.01"
              defaultValue={this.props.price_override_val}
              onChange={this.handleChange}
            />
            <button
              className="btn-tiny ml-1"
              type="button"
              onClick={this.handleClose}>cancel
            </button>
          </div>
        </>
      );
    }
    return (
      <button
        className="btn-tiny"
        type="button"
        onClick={this.handleOpen}>edit price</button>
    );
  }
}


// NONVIS OPTIONS GROUP (is used with the NonVisOptionsMenu)
class NonVisOptionsGroup extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    this.props.onChange(e);
  }

  createOptionsList() {
    switch (this.props.type) {
      case "n7":  // INTEGER
        return (
          <NonVisOptionsIntInput
            label={this.props.label}
            sub_label={this.props.sub_label}
            value={this.props.value.int_val}
            name={this.props.target_group}
            onChange={this.handleChange}
          />
        );
      case "n8":  // BOOLEAN
        return (
          <NonVisOptionsToggle
            checked={this.props.value.bool_val}
            label={this.props.label}
            sub_label={this.props.sub_label}
            name={this.props.target_group}
            onChange={this.handleChange}
          />
        );
      case "n9":  // SELECT
        return (
          <NonVisOptionsSelector
            sel_option_id={this.props.target_group}
            options={this.props.options}
            label={this.props.label}
            sub_label={this.props.sub_label}
            value={this.props.value.option_id}
            onChange={this.handleChange}
            name={this.props.target_group}
          />
        );
    }
  }

  render() {
    const options_list = this.createOptionsList();
    // don't output anything if we got not option elements for this option group
    if (!options_list) {
      return null;
    }
    return (
      <div className="interior-option">
        <>{options_list}</>
      </div>
    );
  }
}

// NONVIS OPTIONS MENU
class NonVisOptionsMenu extends React.Component {
  createOptionGroups() {
    const option_groups = this.props.option_groups;
    const filter_category = this.props.category;  // interior/exterior, etc
    let group_elements = [];
    for (let i in cp.opt_groups_by_weight) {
      let group_id = cp.opt_groups_by_weight[i].id;
      let group = option_groups[group_id];
      // filter by interior or exterior category
      if (group.category == filter_category) {
        group_elements.push(
          <NonVisOptionsGroup
            key={group_id}
            value={this.props.nonvis_options_state[group_id]}
            label={group.label}
            sub_label={group.sub_label}
            onChange={this.props.onChange}
            options={group.options}
            target_group={group_id}
            type={group.type}
          />
        );
      }
    }
    return group_elements;
  }

  render() {
    const option_groups = this.createOptionGroups();

    return (
      <div>
        {option_groups}
        <div className="clearfix"></div>
      </div>
    );
  }
}

class NonVisOptionsToggle extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
    this.handleChildChange = this.handleChildChange.bind(this);
    this.handlePriceOverrideChange = this.handlePriceOverrideChange.bind(this);
  }

  handleChange(e) {
    let new_val = window.cp.current_state.nonvis_options[this.props.name];
    new_val.bool_val = e.target.checked;
    doNonVisOptionChange(this.props.name, new_val);
    this.props.onChange(e.target.checked);
  }

  handleChildChange(val) {
    this.props.onChange(val);
  }

  handlePriceOverrideChange(val) {
    let opt_id = window.cp.settings.option_groups[this.props.name].options[0];
    doNonVisOptionPriceOverrideChange(this.props.name, opt_id, val);
    this.props.onChange(val);
  }

  render() {
    let opt_id = window.cp.settings.option_groups[this.props.name].options[0];
    let opt = window.cp.settings.options[opt_id];
    let cs_opt = window.cp.current_state.nonvis_options[this.props.name];
    let price = formatPrice(opt.item_price, false, ' ', opt.item_price_suffix);
    let allow_over = Boolean(opt.allow_price_over.length && cp_structures_user_has_role(opt.allow_price_over));
    let label = this.props.label;
    let opt_group = window.cp.settings.option_groups[this.props.name];
    let disabled = !opt.enabled || !opt_group.enabled;
    let vis_class = ((opt_group.visible && opt.visible) ? 'visible' : 'hidden');
    let included = null;
    if (window.cp.current_state.model.default_nonvis_options[this.props.name].include_in_base) {
      included = ' <Included>';
    }

    let has_materials = false;
    let has_colors = false;
    let cs_mat = null;
    let color_group_id = null;
    let material_group_name = null;
    // check if this group is controlling material groups
    if (this.props.checked && opt_group.material_groups.length) {
      if (opt && opt.materials.length) {
        if (opt.material_group) {
          has_materials = true;
          cs_mat = window.cp.current_state.materials[opt.material_group];
          if (cs_mat.material) {
            let mat_details = cp.settings.materials[cs_mat.material];
            if (mat_details) {
              color_group_id = mat_details.color_group;
              material_group_name = cp.settings.material_groups[opt.material_group].apply_to_mesh_name;
              if (color_group_id) {
                has_colors = true;
              }
            }
          }
        } else {
          console.log(opt, 'should have a material group because it has materials defined on it.')
        }
      }
    }
    return (
      <div className={vis_class}>
        <label className="mt-2">
          <input name={this.props.name}
                 type="checkbox"
                 onChange={this.handleChange}
                 disabled={disabled}
                 checked={this.props.checked}
          />
          <div className="toggle-option">&nbsp;{label}
            <span className="price">{price}</span>
            &nbsp;
            <span className="included-label">{included}</span>
            &nbsp;
            <InfoPopover title={label} description={opt.description}/>
          </div>
        </label>
        {(this.props.sub_label) && <div className="sub-label">{this.props.sub_label}</div>}
        {(allow_over && this.props.checked) &&
          <NonVisOptionPriceOverride
            onChange={this.handlePriceOverrideChange}
            price_override_val={cs_opt.price_override_val}
            opt_id={opt_id}
          />}
        {(has_materials) && <MaterialSelector
          parent_opt_group_id={this.props.name}
          selector_class_name="option-dropdown"
          options={opt.materials}
          mat_group_id={opt.material_group}
          sel_mat_id={cs_mat.material}
          onChange={this.handleChildChange}
        />}
        {(has_colors) && <ColorSelector
          parent_opt_group_id={this.props.name}
          target_name={material_group_name}
          selector_class_name="option-dropdown"
          color_group_id={color_group_id}
          sel_color_id={cs_mat.color}
          onChange={this.handleChildChange}
        />}
      </div>
    );
  }
}

// NONVIS OPTIONS SELECTOR
class NonVisOptionsSelector extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
    this.handleChildChange = this.handleChildChange.bind(this);
  }

  handleChange(val, actionMeta) {
    if (actionMeta && actionMeta.action == 'select-option') {
      // update current state using the current state settings and just changing the value
      let opt_group_id = this.props.name;
      let new_val = window.cp.current_state.nonvis_options[opt_group_id];
      new_val.option_id = val.value;
      doNonVisOptionChange(opt_group_id, new_val);
    }
    this.props.onChange(val);
  }

  handleChildChange(val) {
    this.props.onChange(val);
  }

  render() {
    let none_opt = {value: -1, label: 'None', enable: true};
    let opt = window.cp.settings.options[this.props.value];
    // for opt group conditions
    let opt_group = window.cp.settings.option_groups[this.props.name];
    let vis_class = (opt_group.visible ? 'visible' : 'hidden');
    // for disabling the entire select list
    let disabled = !opt_group.enabled;

    let require_none = opt_group.optional;
    let select_options = [];
    // loop over every option to create a 'select_options' array containing objects with labels and values
    for (let o in this.props.options) {
      o = this.props.options[o];
      // if the list already has a -1, add it to the select options, but we do this later so we can ensure it is at the top of the list
      if (o == -1) {
        require_none = true;
        continue;
      }
      let opt = window.cp.settings.options[o];
      if (opt.discontinued) {
        continue;
      }
      if (opt.hasOwnProperty('visible') && !opt.visible) {
        continue;
      }
      let suffix = (opt.item_price_suffix ? opt.item_price_suffix : '');
      let price = formatPrice(opt.item_price, false, ' [', suffix + ']', false);
      let label = opt.label + price;
      if (window.cp.current_state.model.default_nonvis_options[this.props.name].include_in_base) {
        if (o == window.cp.current_state.model.default_nonvis_options[this.props.name].option_id) {
          label = opt.label + ' <Included>';
        }
      }
      select_options.push({value: o, label: label, enable: opt.enabled});
    }
    // no options returned, so just don't render this group
    if (!select_options || !select_options.length) {
      return null;
    }
    // we need a 'none' option
    if (require_none) {
      select_options.unshift(none_opt);
    }
    // define the valueFromId function to help lookup values
    const valueFromId = (select_options, sel_option_id) => select_options.find(opt => opt.value === sel_option_id);
    let value = valueFromId(select_options, this.props.value);

    let has_materials = false;
    let has_colors = false;
    let cs_mat = null;
    let color_group_id = null;
    let material_group_name = null;
    // check if this group is controlling material groups
    if (opt_group.material_groups.length) {
      if (opt && opt.materials.length) {
        if (opt.material_group) {
          has_materials = true;
          cs_mat = window.cp.current_state.materials[opt.material_group];
          if (cs_mat.material) {
            let mat_details = cp.settings.materials[cs_mat.material];
            if (mat_details) {
              color_group_id = mat_details.color_group;
              material_group_name = cp.settings.material_groups[opt.material_group].apply_to_mesh_name;
              if (color_group_id) {
                has_colors = true;
              }
            }
          }
        } else {
          console.log(opt, 'should have a material group because it has materials defined on it.')
        }
      }
    }

    return (
      <div className={vis_class}>
        <label>
          {this.props.label}&nbsp;
          {(opt) && <InfoPopover title={opt.label} description={opt.description}/>}
          {(!opt && opt_group) && <InfoPopover title={opt_group.label} description={opt_group.description}/>}
        </label>
        {(this.props.sub_label) && <div className="sub-label">{this.props.sub_label}</div>}
        <Select
          className="option-dropdown"
          options={select_options}
          value={value}
          onChange={this.handleChange}
          menuPortalTarget={document.body}
          name={this.props.name}
          id={'int_opt_' + this.props.name}
          isOptionDisabled={(o) => !o.enable}
          isDisabled={disabled}
        />
        {(has_materials) && <MaterialSelector
          parent_opt_group_id={this.props.name}
          selector_class_name="option-dropdown"
          options={opt.materials}
          mat_group_id={opt.material_group}
          sel_mat_id={cs_mat.material}
          onChange={this.handleChildChange}
        />}
        {(has_colors) && <ColorSelector
          parent_opt_group_id={this.props.name}
          target_name={material_group_name}
          selector_class_name="option-dropdown"
          color_group_id={color_group_id}
          sel_color_id={cs_mat.color}
          onChange={this.handleChildChange}
        />}
      </div>
    );
  }
}


// NONVIS OPTIONS INT INPUT
class NonVisOptionsIntInput extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
    this.handleValidation = this.handleValidation.bind(this);
  }

  handleChange(e) {
    if (e.nativeEvent.inputType == 'insertReplacementText') {
      this.handleValidation(e);
    }
    let opt_group_id = this.props.name;
    let new_val = window.cp.current_state.nonvis_options[opt_group_id];
    new_val.int_val = (e.target.value ? parseInt(e.target.value) : 0);
    // just limit to 0 because our min on the int fields is sometimes set to negative numbers to make the steps work out better
    if (!(new_val.int_val > 0)) {
      new_val.int_val = 0;
    }
    // update the input field to show the modified, validated value
    e.target.value = new_val.int_val;
    // change the value in the current_state and recalculate prices.
    doNonVisOptionChange(opt_group_id, new_val);
    this.props.onChange(e.target.value);
  }

  handleValidation(e) {
    let opt_group_id = this.props.name;
    let opt_group = cp.settings.option_groups[opt_group_id];
    let cur_val = parseInt(e.target.value);
    // VALIDATION
    // integer multiple of validation
    if (cur_val && opt_group.validate_int_mult_of) {
      let valid_val = processIntMultOfString(cur_val, opt_group.validate_int_mult_of);
      if (valid_val != cur_val) {
        e.target.value = valid_val;
      }
    }
  }

  render() {
    // if value is null or 0, just clear the input field with ''
    let default_value = ((!this.props.value) ? '' : this.props.value);
    let opt_group = window.cp.settings.option_groups[this.props.name];
    let opt_id = opt_group.options[0];
    let opt = window.cp.settings.options[opt_id];

    let price = formatPrice(opt.item_price, false, '', opt.item_price_suffix);
    let label = this.props.label;

    let disabled = !opt_group.enabled;
    let vis_class = (window.cp.settings.option_groups[this.props.name].visible ? 'visible' : 'hidden');
    let included = null;
    if (window.cp.current_state.model.default_nonvis_options[this.props.name].include_in_base) {
      included = ' <' + window.cp.current_state.model.default_nonvis_options[this.props.name].int_val + ' Included>';
    }

    // add required popup if this value was forced by a conditional
    // @TODO maybe have .forced put in the cp.settings rather than current_state? Trying to avoid CS in the render layer
    let forced_msg = "";
    if (window.cp.current_state.nonvis_options.hasOwnProperty(this.props.name)) {
      let cur_value = window.cp.current_state.nonvis_options[this.props.name];
      if (cur_value.hasOwnProperty("forced") && cur_value.forced) {
        forced_msg = " (required)";
        let c = window.cp.settings.conditionals[cur_value.forced];
        if (c.message) {
          forced_msg = <InfoPopover title="Why is this required?" description={c.message} alt_icon=" *Required"/>;
        }
      }
    }

    // do some adjustment to the min, max and step based on the 'multiple of' validation
    let step = 1;
    let min = 0;
    let max = null;  // no max
    // here we figure out the min and step for the number input field. This is based on our int_mult_of validation string
    if (opt_group.validate_int_mult_of) {
      // match text that looks like #+#  2+1 for odd numbers, etc.
      let match = /(\d+)([+]?)(\d*)/g.exec(opt_group.validate_int_mult_of);
      if (match[1]) {
        step = parseInt(match[1]);
        // if we have an offset from 0 make sure we allow this min, so our step will start at that number and then work properly.
        if (match[3]) {
          min -= (step - parseInt(match[3]));
        }
      }
    }

    return (
      <div className={"int-option " + vis_class}>
        <label>
          <div>&nbsp;{label}&nbsp;
            <span className="price">{price}</span>&nbsp;
            <InfoPopover title={label} description={opt.description}/>
          </div>
        </label><br/>
        {(this.props.sub_label) && <div className="sub-label">{this.props.sub_label}</div>}
        {forced_msg && <div className="sub-label">{forced_msg}</div>}
        <input id={'int_opt_' + this.props.name}
               name={this.props.name}
               type="number"
               min={min}
               max={max}
               step={step}
               value={default_value}
               onChange={this.handleChange}
               onBlur={this.handleValidation}
               disabled={disabled}
        />
        <span className="included-label">{included}</span>
      </div>
    );
  }
}


// INFO POPOVER
class InfoPopover extends React.Component {
  componentDidMount() {
    this.$el = $(this.el);
    this.$el.popover({container: 'body'});
    $('.popover-dismiss').popover({trigger: 'focus'});
  }

  render() {
    let description = this.props.description;
    if (!description) {
      return null;
    }
    let title = this.props.title;
    let icon = ((description == "") ? '' : <>&#9432;&#8201;info</>); // thin space char used here #8201
    // allow alternative icon text.
    if (this.props.alt_icon) {
      icon = <>{this.props.alt_icon}</>;
    }

    let placement = "left";
    if(this.props.placement) {
      placement = this.props.placement;
    }

    return (
      <a ref={el => this.el = el} href="#"
         onClick={(e) => {
           e.preventDefault();
         }}
         className="info-popover" role="button" tabIndex="-1"
         data-html="true"
         data-toggle="popover"
         data-trigger="focus"
         data-placement={placement}
         data-original-title={title}
         data-content={description}>{icon}
      </a>
    );
  }
}


// SHED CONFIG OUTPUT
class StructureDetailsOutput extends React.Component {
  render() {
    const cd_struct = window.cp.config_data.structure;
    const cs = window.cp.current_state;
    let base_price = cd_struct.model_price;
    let base_overridden = null;
    let build_overridden = null;

    // the new way of showing when the price is overridden (only when actually manually overridden)
    if (!window.cp.is_anonymous) {
      if (cs.hasOwnProperty('base_price_override') && cs.base_price_override) {
        base_overridden = <div className="overridden-price-label">(overridden)</div>;
      }
      if (cs.hasOwnProperty('base_build_price_override') && cs.base_build_price_override) {
        build_overridden = <div className="overridden-price-label">(overridden)</div>;
      }
    }

    // make markup to display in the Shed Calculated Values popup
    let model_calcs_markup = null;
    let overall_height = null;
    if (cp.model_calcs) {
      model_calcs_markup = 'Wall Area: ' + cp.model_calcs.wall_area + ' sq.ft.<br/>';
      model_calcs_markup += 'Interior Wall Area: ' + cp.model_calcs.interior_wall_area + ' sq.ft.<br/>';
      model_calcs_markup += 'Roof Area: ' + cp.model_calcs.roof_area + ' sq.ft.<br/>';
      model_calcs_markup += 'Ceiling Area: ' + cp.model_calcs.ceiling_area + ' sq.ft.<br/>';
      model_calcs_markup += 'Base Area: ' + cp.model_calcs.base_area + ' sq.ft.<br/>';
      model_calcs_markup += 'Interior Floor Area: ' + cp.model_calcs.interior_floor_area + ' sq.ft.<br/>';
      model_calcs_markup += 'Wall Perimeter: ' + cp.model_calcs.wall_perimeter + ' ft.<br/>';
      model_calcs_markup += 'Overall Height: ' + (cp.model_calcs.overall_height ? formatFeetInches(cp.model_calcs.overall_height) : '<em>(unknown)</em>') + ' <br/>';  // shown as feet + inches
      if (cp.model_calcs.overall_height) {
        overall_height = formatFeetInches(cp.model_calcs.overall_height);
      }
    }
    return (
      <table className="structure-details">
        <tbody>
        <tr>
          <th>Shed Details {(!window.cp.is_anonymous) &&
            <InfoPopover title="Shed Calculated Values" description={model_calcs_markup}/>}</th>
          <th>&nbsp;</th>
        </tr>
        {(!window.cp.is_anonymous && window.cp.view_build_pricing) && <tr>
          <td>Build Price:</td>
          <td className="text-right"><InfoPopover title="Build Price Calculations"
                                                  description={cp.config_data.build_price_calc_details}/>&nbsp;&lt;build
            price&gt; {formatPrice(cp.config_data.total_build_price)}{build_overridden}</td>
        </tr>}
        <tr>
          <td>Style: <strong>{cs.model.label}</strong></td>
          <td className="text-right">&lt;base price&gt; {formatPrice(base_price)}{base_overridden}</td>
        </tr>
        <tr>
          <td>Size: <strong>{cp.settings.base_sizes[cd_struct.size].label}</strong></td>
          <td>&nbsp;</td>
        </tr>
        <tr>
          <td>Siding: <strong>{cp.settings.materials[cd_struct.siding_material].label}</strong></td>
          <td className="text-right">{formatPrice(cd_struct.siding_material_price, false)}</td>
        </tr>
        <tr>
          <td>Siding
            Color: <strong>{getColorByColorId(cd_struct.siding_color).label}{cd_struct.hasOwnProperty('custom_siding_color') && ' (' + cd_struct.custom_siding_color + ')'}</strong>
          </td>
          <td className="text-right">{formatPrice(cd_struct.siding_color_price, false)}</td>
        </tr>
        <tr>
          <td>Trim
            Color: <strong>{getColorByColorId(cd_struct.trim_color).label}{cd_struct.hasOwnProperty('custom_trim_color') && ' (' + cd_struct.custom_trim_color + ')'}</strong>
          </td>
          <td className="text-right">{formatPrice(cd_struct.trim_color_price, false)}</td>
        </tr>
        <tr>
          <td>Roofing: <strong>{cp.settings.materials[cd_struct.roof_material].label}</strong></td>
          <td className="text-right">{formatPrice(cd_struct.roof_material_price, false)}</td>
        </tr>
        <tr>
          <td>Roof
            Color: <strong>{getColorByColorId(cd_struct.roof_color).label}{cd_struct.hasOwnProperty('custom_roof_color') && ' (' + cd_struct.custom_roof_color + ')'}</strong>
          </td>
          <td className="text-right">{formatPrice(cd_struct.roof_color_price, false)}</td>
        </tr>
        <tr>
          <td>Wall Height: <strong>{cp.settings.base_heights[cd_struct.height].label}</strong></td>
          <td className="text-right">{formatPrice(cd_struct.height_price, false)}</td>
        </tr>
        {(overall_height) && <tr>
          <td>Total Building Height: <strong>{overall_height}</strong></td>
          <td>&nbsp;</td>
        </tr>}
        </tbody>
      </table>
    );
  }
}

class StructureVisOptionsOutput extends React.Component {
  createTableRows() {
    let output = [];
    for (let i in cp.config_data.vis_options) {
      let vis_opt_data = cp.config_data.vis_options[i];
      // if this is a credit use the 'credit_label' otherwise use the standard display label for this option
      let col1 = window.cp.settings.options[vis_opt_data.option_id].label;
      let col2 = (vis_opt_data.included_in_base ? <em>{'<Included>'}</em> : formatPrice(vis_opt_data.price_to_show));
      // if this is a credit update col1 and col2
      if (vis_opt_data.credit) {
        // if has quantity of more than 1
        if (vis_opt_data.credit_qty > 1) {
          col1 = <span><span
            className="nowrap">Removed Included:</span> <strong>{col1 + ' × ' + vis_opt_data.credit_qty}</strong></span>;
        } else {
          col1 = <span><span className="nowrap">Removed Included:</span> <strong>{col1}</strong></span>;
        }
        col2 = <span className="credit-price"><em>(Credit) </em> {formatPrice(vis_opt_data.price_to_show)}</span>;
      }
      output.push(<TableRow key={i} col1={col1} col2={col2}/>);
      // ATTRIBUTES
      for (let attr_group_id in vis_opt_data.attributes) {
        let attr_data = vis_opt_data.attributes[attr_group_id];
        let col1 = "\u00a0↳" + window.cp.settings.options[attr_data.option_id].label;
        let col2 = '';
        if (attr_data.price) {
          col2 = formatPrice(attr_data.price);
        }
        output.push(<TableRow key={i + '_' + attr_group_id} col1={col1} col2={col2}/>);
      }
      // ADDONS
      for (let addon_group_id in vis_opt_data.addons) {
        let addon_data = vis_opt_data.addons[addon_group_id];
        let col1 = "\u00a0↳" + window.cp.settings.options[addon_data.option_id].label;
        let col2 = formatPrice(addon_data.price);
        output.push(<TableRow key={i + '_' + addon_group_id} col1={col1} col2={col2}/>);
      }
    }
    return output;
  }

  render() {
    const rows = this.createTableRows();
    return (
      <table className="vis-option-details">
        <tbody>
        <tr>
          <th>Visual Options</th>
          <th>&nbsp;</th>
        </tr>
        {rows}
        </tbody>
      </table>
    );
  }
}


class StructureNonVisOptionsOutput extends React.Component {
  createTableRows() {
    let output = [];
    for (let key in cp.config_data.nonvis_options) {
      let nonvis_opt = window.cp.config_data.nonvis_options[key];
      let opt_group = window.cp.settings.option_groups[key];
      let cur_value = window.cp.current_state.nonvis_options[key];
      let col1 = null;
      let col2 = null;

      // insert credit lines where needed.
      if (nonvis_opt.credit) {
        col2 = <span className="credit-price"><em>(Credit) </em> {formatPrice(nonvis_opt.credit_price, false)}</span>;
        switch (opt_group.type) {
          case 'n7':  // INTEGER
            col1 = <span><span
              className="nowrap">Removed Included:</span> <strong>{opt_group.label + ' × ' + nonvis_opt.credit_qty}</strong></span>;
            break;
          case 'n8':  // BOOLEAN
            col1 = <span><span className="nowrap">Removed Included:</span> <strong>{opt_group.label}</strong></span>;
            break;
          case 'n9':  // SELECT
            if (nonvis_opt.credit_option_id) {
              col1 = <span><span
                className="nowrap">Removed Included:</span> <strong>{window.cp.settings.options[nonvis_opt.credit_option_id].label}</strong></span>;
            }
            break;
        }
        if (col1) {
          output.push(<TableRow key={key + '_credit'} col1={col1} col2={col2}/>);
        }
      }

      col1 = null;
      col2 = null;
      // only include this opt_group if we are not set to hide if zero or if price is not zero
      // (hides if price is 0 and set to hide_w_zero)
      if (nonvis_opt.included_in_base || (!opt_group.hide_w_zero) || (nonvis_opt.price_to_show != 0)) {
        // forced conditionals are tracked and can be labeled here. @TODO only integer options are labeled at the moment. We could show message from conditional here as well.
        let forced_msg = "";
        if (cur_value.hasOwnProperty("forced") && cur_value.forced) {
          forced_msg = " (required)";
          let c = window.cp.settings.conditionals[cur_value.forced];
          if (c.message) {
            forced_msg = <InfoPopover title="Why is this required?" description={c.message} alt_icon=" *Required"/>;
          }
        }
        col2 = formatPrice(nonvis_opt.price_to_show, false);
        switch (opt_group.type) {
          case 'n7':  // INTEGER
            col1 = <span>{opt_group.label + ': '}<strong>{cur_value.int_val}</strong>{forced_msg}</span>;
            break;
          case 'n8':  // BOOLEAN
            if (cur_value.bool_val == true) {
              col1 = opt_group.label;
            }
            break;
          case 'n9':  // SELECT
            if (cur_value.option_id != -1 && cur_value.option_id) {
              col1 =
                <span>{opt_group.label + ': '}<strong>{cp.settings.options[cur_value.option_id].label}</strong></span>;
            }
            break;
        }
        // handle the display for 'included in base' options
        if (nonvis_opt.included_in_base) {
          col2 = <em>{'<Included>'}</em>;
          // do some extra processing for included options that are the Integer type, since they may not all be included
          if (opt_group.type == 'n7') {
            col2 =
              <span><em>{'<' + nonvis_opt.included_in_base_count + ' Included>'} </em> {formatPrice(nonvis_opt.price_to_show, false)}</span>;
          }
          // do some extra processing for included options that are the Select type, since they may not all be included
          else if (opt_group.type == 'n9') {
            if (window.cp.current_state.model.default_nonvis_options[key].include_in_base) {
              // included = ' <' +  window.cp.current_state.model.default_nonvis_options[key].int_val + ' Included>';
              col2 = <span><em>{'<Included>'} </em> {formatPrice(nonvis_opt.price_to_show, false)}</span>;
            }
          }
        }
        if (col1) {
          output.push(<TableRow key={key} col1={col1} col2={col2}/>);
          // add the material line if needed
          if (nonvis_opt.material) {
            let col1 = "\u00a0↳Material: " + window.cp.settings.materials[nonvis_opt.material].label;
            let col2 = '';
            if (nonvis_opt.material_price) {
              col2 = formatPrice(nonvis_opt.material_price, false);
            }
            output.push(<TableRow key={key + '_material'} col1={col1} col2={col2}/>);
            // output color as well if we have one
            if (nonvis_opt.color) {
              let col1 = "\u00a0↳Color: " + getColorByColorId(nonvis_opt.color).label;
              let col2 = '';
              if (nonvis_opt.color_price) {
                col2 = formatPrice(nonvis_opt.color_price, false);
              }
              output.push(<TableRow key={key + '_color'} col1={col1} col2={col2}/>);
            }
          }
        }
      }
    }
    return output;
  }

  render() {
    const rows = this.createTableRows();
    return (
      <table className="nonvis-option-details">
        <tbody>
        <tr>
          <th>Non-Visual Options</th>
          <th>&nbsp;</th>
        </tr>
        {rows}
        </tbody>
      </table>
    );
  }
}

class StructureCustOptionsOutput extends React.Component {
  createTableRows() {
    let output = [];
    for (let i in cp.config_data.cust_options) {
      let cust_opt_data = cp.config_data.cust_options[i];
      let col1 = <span>{cust_opt_data.description + ': '}<strong>{cust_opt_data.quantity}</strong></span>;
      let col2 = formatPrice(cust_opt_data.price_to_show);
      output.push(<TableRow key={i} col1={col1} col2={col2}/>);
    }
    return output;
  }

  render() {
    const rows = this.createTableRows();
    if (rows.length == 0) {
      return null;
    }
    return (
      <table className="cust-option-details">
        <tbody>
        <tr>
          <th>Custom Options</th>
          <th>&nbsp;</th>
        </tr>
        {rows}
        </tbody>
      </table>
    );
  }
}

class TableRow extends React.Component {
  render() {
    return (
      <tr>
        <td>{this.props.col1}</td>
        <td className="text-right">{this.props.col2}</td>
      </tr>
    );
  }
}

class StructureNotesOutput extends React.Component {
  render() {
    return (
      <div
        className="structure-notes">{cp.config_data.structure.structure_notes && 'Notes:'} {cp.config_data.structure.structure_notes}</div>
    );
  }
}

class ShedPrice extends React.Component {
  render() {
    let rto_payment_msg = 'This monthly payment estimate an approximation because there may still be other possible fees. The accurate amount will be determined from information collected during checkout. ';
    rto_payment_msg += 'This is calculated for a ' + cp.default_rto_term.term_length + ' month term. ';
    if (cp.config_data.rto_payment_tax_estimate) {
      rto_payment_msg += 'Taxes were included using ' + cp.config_data.rto_payment_tax_rate + '% sales tax.';
    } else {
      rto_payment_msg += '(Taxes are not included in this price.)';
    }
    return (
      <>
        <div className="shed-total">Total: {formatPrice(cp.config_data.total_price, false)}</div>
        {(cp.config_data.rto_payment_estimate > 0) && <div className="rto-payment-estimate">
          <InfoPopover title="Approximate Monthly Payment" description={rto_payment_msg}/>&nbsp;Approx. Monthly
          Payment: {formatPrice(cp.config_data.rto_payment_estimate, false)}</div>
        }
      </>
    );
  }
}


class StructureNotes extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    window.cp.current_state.structure_notes = e.target.value;
    this.props.onChange(e.target.value);
  }

  render() {
    return (
      <div>
        <label>Design Notes:</label>
        <div><textarea value={window.cp.current_state.structure_notes} onChange={this.handleChange} rows="4" cols="75"/>
        </div>
      </div>
    );
  }
}

class CustomOptionsMenu extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    let new_uid = getCustomOptionUID();
    let build_price_value = window.cp.settings.company.cust_option_default_build_price_value;
    build_price_value = ((build_price_value == null) ? '' : build_price_value);
    let build_price_calc_method = window.cp.settings.company.cust_option_default_build_price_calc_method;

    window.cp.current_state.cust_options.push({
      uid: new_uid,
      description: '',
      price_method: '',
      price_value: '',
      quantity: 1,
      build_price_method: build_price_calc_method,
      build_price_value: build_price_value,
    });
    initReactUI();
  }

  createCustomOptions() {
    const custom_options = window.cp.current_state.cust_options;
    let custom_options_output = [];
    for (let i in custom_options) {
      if (custom_options[i]) {
        let cust_opt = custom_options[i];
        if (!cust_opt.hasOwnProperty('uid')) {
          cust_opt.uid = getCustomOptionUID();
        }
        custom_options_output.push(
          <CustomOption
            onChange={this.props.onChange}
            id={i}
            key={cust_opt.uid}
          />
        );
      }
    }
    return custom_options_output;
  }

  render() {
    const custom_options = this.createCustomOptions();
    return (
      <div className="custom-options">
        <hr/>
        <h4>Custom Options</h4>
        {custom_options}
        <button
          type="button"
          onClick={this.handleClick}
          className={'add-cust-opt btn-gray'}>
          Add Another
        </button>
      </div>
    );
  }
}

class CustomOption extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    // remove the option and update the ui
    window.cp.current_state.cust_options.splice(e.target.attributes.data_option_key.value, 1);
    initReactUI();
  }

  render() {
    let cs_value = window.cp.current_state.cust_options[parseInt(this.props.id)];
    let price_value_label = 'Total Price';
    let cust_opt_total = '';
    let calculation_method_formula = '';

    let build_price_value_label = '';
    let cust_opt_build_price_total = '';
    let build_price_calculation_method_formula = '';

    // @TODO this lookup code could be broken into a function as it is used in several places.
    // labels for the price value field based on the price method
    if (window.cp.price_calc_methods_lookup.hasOwnProperty(cs_value.price_method)) {
      let method = window.cp.price_calc_methods_lookup[cs_value.price_method];
      price_value_label = method.price_value_label;
      calculation_method_formula = method.formula_description;
    }

    // labels for the build price value field based on the price method
    if (window.cp.price_calc_methods_lookup.hasOwnProperty(cs_value.build_price_method)) {
      let method = window.cp.price_calc_methods_lookup[cs_value.build_price_method];
      build_price_value_label = method.price_value_label;
      build_price_calculation_method_formula = method.formula_description;
    }
    if (window.cp.config_data.cust_options[parseInt(this.props.id)] !== undefined) {
      cust_opt_total = formatPrice(window.cp.config_data.cust_options[parseInt(this.props.id)].price_to_show);
      cust_opt_build_price_total = formatPrice(window.cp.config_data.cust_options[parseInt(this.props.id)].build_price_to_show);
    }

    return (
      <div className={'custom-option'}>
        <div className={'row'}>
          <div className={'col-md-8'}>
            <CustomOptInput
              id={this.props.id + '_desc'}
              customType="description"
              label="Description"
              maxLength="64"
              value={cs_value.description}
              onChange={this.props.onChange}/>
          </div>
          <div className={'col-md-4'}>
            <CustomOptInput
              id={this.props.id + '_qty'}
              customType="quantity"
              label="Quantity"
              value={cs_value.quantity}
              onChange={this.props.onChange}/>
          </div>
        </div>
        <div className={'row'}>
          <div className={'col-md-8'}>
            <label>Price Method</label>
            <PriceMethodSelector
              onChange={this.props.onChange}
              id={this.props.id + '_price_method'}
              opt_index={this.props.id}
              price_type={'price_method'}/>
          </div>
          <div className={'col-md-4'}>
            <CustomOptInput
              id={this.props.id + '_value'}
              customType="price_value"
              label={price_value_label}
              value={cs_value.price_value}
              onChange={this.props.onChange}/>
          </div>
        </div>
        <div className={'row'}>
          <div className={'col-md-8 price-method-formula'}>
            {calculation_method_formula}
          </div>
          <div className={'col-md-4 cust-opt-total'}>
            {cust_opt_total}
          </div>
        </div>

        {(!window.cp.is_anonymous && window.cp.view_build_pricing) &&
          <div>
            <div className={'row'}>
              <div className={'col-md-8'}>
                <label>Build Price Method</label>
                <PriceMethodSelector
                  onChange={this.props.onChange}
                  id={this.props.id + '_build_price_method'}
                  opt_index={this.props.id}
                  price_type={'build_price_method'}/>
              </div>
              <div className={'col-md-4'}>
                <CustomOptInput
                  id={this.props.id + '_build_price_value'}
                  customType="build_price_value"
                  label={build_price_value_label}
                  value={cs_value.build_price_value}
                  onChange={this.props.onChange}/>
              </div>
            </div>
            <div className={'row'}>
              <div className={'col-md-8 price-method-formula'}>
                {build_price_calculation_method_formula}
              </div>
              <div className={'col-md-4 cust-opt-total'}>
                {cust_opt_build_price_total}
              </div>
            </div>
          </div>
        }


        <div>
          <div className={'row'}>
            <div className={'col-md-8'}>
              <CustomOptToggle
                id={this.props.id + '_non_tax'}
                label="Non-Taxable"
                customType="non_tax"
                onChange={this.props.onChange}
                value={cs_value.non_tax}
              />
            </div>
            <div className={'col-md-4 custom-option-actions'}>
              <button
                type="button"
                onClick={this.handleClick}
                data_option_key={this.props.id}
                className={'btn btn-secondary remove-cust-opt'}
              >
                Remove
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


class CustomOptInput extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    window.cp.current_state.cust_options[parseInt(this.props.id)][this.props.customType] = e.target.value;
    this.props.onChange(e);
  }

  render() {
    if (this.props.type == 'price_value') {
      return (
        <div>
          <label>{this.props.label}</label>
          <input id={this.props.id + '_' + this.props.customType}
                 type="number"
                 step="0.01"
                 value={(this.props.value ? this.props.value : '')}
                 onChange={this.handleChange}/>
        </div>
      );
    } else {
      let maxLength = (this.props.maxLength ? this.props.maxLength : null);
      return (
        <div>
          <label>{this.props.label}</label>
          <input id={this.props.id + '_' + this.props.customType}
                 type="text"
                 maxLength={maxLength}
                 value={(this.props.value ? this.props.value : '')}
                 onChange={this.handleChange}/>
        </div>
      );
    }
  }
}


class CustomOptToggle extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(e) {
    window.cp.current_state.cust_options[parseInt(this.props.id)][this.props.customType] = e.target.checked;
    this.props.onChange(e);
  }

  render() {
    return (
      <div>
        <input id={this.props.id + '_' + this.props.customType}
               type="checkbox"
               checked={(this.props.value ? this.props.value : false)}
               onChange={this.handleChange}/>
        <label>&nbsp;{this.props.label}&nbsp;
          <InfoPopover title="Non-Taxable"
                       description="Checking this box will prevent the price of this option from being taxed when calculating the taxes for the order."/>
        </label>
      </div>
    );
  }
}


class PriceMethodSelector extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(val) {
    window.cp.current_state.cust_options[this.props.opt_index][this.props.price_type] = val.value;
    this.props.onChange(val);
  }

  render() {
    let cur_method = window.cp.current_state.cust_options[this.props.opt_index][this.props.price_type];
    let select_options = [];
    if (this.props.price_type == 'build_price_method') {
      select_options.push({value: -1, label: 'None (Use Retail Price)', enable: true});
      if (!cur_method) {
        cur_method = -1;
      }
    }
    for (let method_id in window.cp.price_calc_methods_lookup) {
      let method = window.cp.price_calc_methods_lookup[method_id];
      // limit this list to only the allowed for custom opts methods
      if (method.avail_on_custom_opts) {
        select_options.push({value: method_id, label: method.label});
      }
    }
    const valueFromId = (select_options, sel_option_id) => select_options.find(opt => opt.value === sel_option_id);
    return (
      <Select
        options={select_options}
        value={valueFromId(select_options, cur_method)}
        onChange={this.handleChange}
        menuPortalTarget={document.body}
        className={'price-method-selector'}
        classNamePrefix="price-method"
      />
    );
  }
}


class BasePriceOverride extends React.Component {
  constructor(props) {
    super(props);
    // bind the handler to this, so this will point to this object in the handler
    this.handlePriceOverrideChange = this.handlePriceOverrideChange.bind(this);
    this.handleBuildPriceOverrideChange = this.handleBuildPriceOverrideChange.bind(this);
  }

  handlePriceOverrideChange(e) {
    window.cp.current_state.base_price_override = e.target.value;
    this.props.onChange(e);
  }

  handleBuildPriceOverrideChange(e) {
    window.cp.current_state.base_build_price_override = e.target.value;
    this.props.onChange(e);
  }

  render() {
    let base_price_override = "";
    let base_build_price_override = "";
    if (window.cp.current_state.hasOwnProperty('base_price_override')) {
      base_price_override = window.cp.current_state.base_price_override;
      base_build_price_override = window.cp.current_state.base_build_price_override;
    }
    let orig_prices = window.cp.current_state.non_overridden_prices;

    return (
      <div className="price-overrides-form">
        <hr/>
        <h4>Price Overrides</h4>
        <table className="price-overrides-form-table">
          <tbody>
          <tr>
            <td><label>Base Price</label></td>
            <td className="text-right">
              <label>$&nbsp;</label>
              <input id="base-price-override-input"
                     type="number"
                     step="0.01"
                     defaultValue={base_price_override}
                     onChange={this.handlePriceOverrideChange}/>
              <br/>
              <em>original: {formatPrice(orig_prices.base_price, false)}</em>
            </td>
          </tr>
          <tr>
            <td><label>Base Build Price</label></td>
            <td className="text-right">
              <label>$&nbsp;</label>
              <input id="base-build-price-override-input"
                     type="number"
                     step="0.01"
                     defaultValue={base_build_price_override}
                     onChange={this.handleBuildPriceOverrideChange}/>
              <br/>
              <em><InfoPopover title="Build Price Calculations"
                               description={cp.config_data.build_price_calc_details}/>&nbsp; original: {formatPrice(orig_prices.base_build_price, false)}
              </em>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    );
  }
}


// UI APP
class StructureDesignerApp extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleSnapChange = this.handleSnapChange.bind(this);
    this.handleDimensionChange = this.handleDimensionChange.bind(this);

    this.state = {current_state: this.props.current_state};
  }

  handleChange(val) {
    this.setState({current_state: window.cp.current_state});
    // renders the scene if 3d
    renderSingleFrame();
  }

  // does the drag drop snap checkbox here because I didn't make a sub-component for this
  handleSnapChange(e) {
    let do_snap = e.target.checked;
    // set the value in the current state
    setSnapping(do_snap);
    // update the ui
    this.handleChange(do_snap);
  }

  handleDimensionChange(e) {
    let show_dimensions = e.target.checked;
    // set the value in the current state
    setShowDimensions(show_dimensions);
    // update the ui
    this.handleChange(show_dimensions);
  }

  render() {
    const cs = this.props.current_state;
    const settings = window.cp.settings;
    const vis_opts_menu_label = 'Select option to add it to the ' + (window.cp.is_3d ? 'highlighted wall.' : 'floor plan.');
    // evaluate the conditionals
    evaluateAllConditionals();
    // do the two passes for the config data calculations, since some are based on others.
    updateCurrentConfigData();
    // updateCurrentConfigData must be called before this function so the prices will be accurate
    updateOptionPricingData();
    let roof_mat = cs.materials[cp.material_group_lookup.roof];
    let roof_details = settings.materials[roof_mat.material];
    let siding_mat = cs.materials[cp.material_group_lookup.siding];
    let siding_details = settings.materials[siding_mat.material];
    let trim_mat = cs.materials[cp.material_group_lookup.trim];
    let overall_height = settings.base_heights[cs.height].overall_height;
    if (overall_height) {
      overall_height = formatFeetInches(overall_height);
    }
    return (
      <React.Fragment>
        <Accordion onChange={this.handleChange}>
          <div label="CHOOSE STYLE / SIZE">
            <div className="container">
              <StructureStyleSelector
                label="Shed Style"
                options={settings.models}
                group_options={settings.model_groups}
                sel_model_id={cs.model.model_id}
                sel_group_id={cs.model_group}
                onChange={this.handleChange}
              />
              <div className="row size-selectors">
                <div className="col-6 dimensions-selector">
                  <label>Size (width × length)
                    <StructureSizeSelector
                      options={cs.model.sizes}
                      sel_size_id={cs.size}
                      onChange={this.handleChange}
                    />
                  </label>
                </div>
                <div className="col-6 height-selector">
                  <label>Wall Height
                    <StructureHeightSelector
                      options={cs.model.heights}
                      sel_height_id={cs.height}
                      onChange={this.handleChange}
                    />
                    {overall_height &&
                      <span className="text-muted overall-height">Total building height: {overall_height}</span>}
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div label="SIDING / ROOFING">
            <div>
              <label>
                Siding Material&nbsp;
                <InfoPopover title={siding_details.label} description={siding_details.description}/>
              </label>
              <MaterialSelector
                options={settings.material_groups[cp.material_group_lookup.siding].materials}
                mat_group_id={cp.material_group_lookup.siding}
                sel_mat_id={siding_mat.material}
                onChange={this.handleChange}
              />
              <ColorSelector
                label="Siding Color"
                target_name="siding"
                color_group_id={settings.materials[siding_mat.material].color_group}
                sel_color_id={siding_mat.color}
                onChange={this.handleChange}
              />
              <ColorSelector
                label="Trim Color"
                target_name="trim"
                color_group_id={settings.materials[trim_mat.material].color_group}
                sel_color_id={trim_mat.color}
                onChange={this.handleChange}
              />
            </div>
            <br/>
            <div>
              <label>
                Roofing Material&nbsp;
                <InfoPopover title={roof_details.label} description={roof_details.description}/>
              </label>
              <MaterialSelector
                options={settings.material_groups[cp.material_group_lookup.roof].materials}
                mat_group_id={cp.material_group_lookup.roof}
                sel_mat_id={roof_mat.material}
                onChange={this.handleChange}
              />
              <ColorSelector
                label="Roof Color"
                target_name="roof"
                color_group_id={settings.materials[roof_mat.material].color_group}
                sel_color_id={roof_mat.color}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div label="EXTERIOR (doors, windows, etc)">
            <div>
              <div>
                <VisOptionsMenu
                  label={vis_opts_menu_label}
                  category="n11"  // exterior
                  options={settings.options}
                  option_groups={settings.option_groups}
                  onChange={this.handleChange}
                />
                {/*DangerouslySetInnerHTML lets react give up control over the inner html and we can set it from a string*/}
                <div className="addon-instructions"
                     dangerouslySetInnerHTML={{__html: getTextOverride('order_form_addon_msg', '<span><span className="asterisk">** </span>Click on the windows/doors on the 3d model to add ramps, shutters, etc. Click and drag to move them.</span>')}}></div>
                <ButtonGroup>
                  {window.cp.is_3d && <ActionButton label="Clear Wall" callback={doClearWall} action="none"/>}
                  <ActionButton label="Clear All" callback={doClearAll} action="none"/>
                </ButtonGroup>
                {window.cp.is_3d && <div>
                  <label className="switch mt-2">
                    <input id="snap-on"
                           name="snap-on"
                           type="checkbox"
                           data-toggle="toggle"
                           onChange={this.handleSnapChange}
                           defaultChecked={cs.snap_on}
                    />
                    <div className="slider round"></div>
                  </label>
                  <div className="toggle-option">&nbsp; Drag-n-Drop Snapping</div>
                </div>}
                {window.cp.is_3d && <div>
                  <label className="switch mt-2">
                    <input id="dimensions-on"
                           name="dimensions-on"
                           type="checkbox"
                           data-toggle="toggle"
                           onChange={this.handleDimensionChange}
                           defaultChecked={cs.dimensions_on}
                    />
                    <div className="slider round"></div>
                  </label>
                  <div className="toggle-option">&nbsp; Show dimensions when placing options</div>
                </div>}
              </div>
              <NonVisOptionsMenu
                label="Non-Visible Exterior Options."
                category="n11"  // exterior
                options={settings.options}
                option_groups={settings.option_groups}
                nonvis_options_state={cs.nonvis_options}
                onChange={this.handleChange}
              />
            </div>
          </div>
          <div label="INTERIOR (floor, loft, etc)">
            <VisOptionsMenu
              label={vis_opts_menu_label}
              category="n10"  // interior
              options={settings.options}
              option_groups={settings.option_groups}
              onChange={this.handleChange}
            />
            <div>Add optional internal options, not visible on {window.cp.is_3d ? '3d model' : 'floor plan'}</div>
            <NonVisOptionsMenu
              label="Interior Options."
              category="n10"  // interior
              options={settings.options}
              option_groups={settings.option_groups}
              nonvis_options_state={cs.nonvis_options}
              onChange={this.handleChange}
            />
          </div>
          <div label="ADDITIONAL DETAILS">
            <NonVisOptionsMenu
              label="Delivery Options."
              category="n300" // delivery
              options={settings.options}
              option_groups={settings.option_groups}
              nonvis_options_state={cs.nonvis_options}
              onChange={this.handleChange}
            />
            <StructureNotes onChange={this.handleChange}/>
            {(!window.cp.is_anonymous) && <CustomOptionsMenu onChange={this.handleChange} id="cust_opt_1"/>}
            {(!window.cp.is_anonymous && window.cp.view_build_pricing) &&
              <BasePriceOverride onChange={this.handleChange} id="base_price_override"/>}
          </div>
          <div label="ORDER DETAILS" details={formatPrice(cp.config_data.total_price, false)}>
            <div>
              <StructureDetailsOutput/>
              <StructureVisOptionsOutput/>
              <StructureNonVisOptionsOutput/>
              <StructureCustOptionsOutput/>
              <StructureNotesOutput/>
              <ShedPrice/>
            </div>
          </div>
        </Accordion>
        {(window.cp.is_anonymous && !window.cp.process_barn) && <div className="structure-spec-submit">
          <ActionButton label={getTextOverride('order_form_anonymous_quote_btn', 'Submit Quote')}
                        callback={doSubmitQuote} action="process"
                        extraClasses={"submit-quote " + (window.cp.allow_drafts ? "col-sm-6 " : "") + "btn-gray"}/>
          {(window.cp.allow_drafts) &&
            <ActionButton label={getTextOverride('order_form_anonymous_draft_btn', 'Save & Email Link')}
                          callback={doEmailLink} action="process" extraClasses={"col-sm-6 btn-gray"}/>}
          {(settings.company.allow_anonymous_checkout && !window.cp.associated_dealer.disable_checkout) &&
            <ActionButton label={getTextOverride('order_form_anonymous_order_btn', "Order Now")} callback={doOrderNow}
                          action="process" extraClasses={"order-now sf-btn-primary"}/>}
        </div>}
        {(!window.cp.is_anonymous && !window.cp.process_barn) && <div className="structure-spec-submit">
          <ActionButton label={getTextOverride('order_form_quote_btn', "Save Quote")} callback={doSubmitQuote}
                        action="process"
                        extraClasses={"submit-quote " + (window.cp.allow_drafts ? "col-sm-6 " : "") + "btn-gray"}/>
          {(window.cp.allow_drafts) &&
            <ActionButton label={getTextOverride('order_form_draft_btn', "Save Draft")} callback={doEmailLink}
                          action="process" extraClasses={"col-sm-6 btn-gray"}/>}
          {(!window.cp.is_only_dealer) &&
            <ActionButton label={getTextOverride('order_form_work_order_btn', "Save Work Order")}
                          callback={doSaveInventory} action="process" extraClasses={"save-inventory btn-gray"}/>}
          <ActionButton label={getTextOverride('order_form_order_btn', "Save Order")} callback={doSaveBarn}
                        action="process" extraClasses={"order-now sf-btn-primary"}/>
        </div>}
        {(window.cp.process_barn) && <div className="structure-spec-submit">
          <ActionButton label={'Update ' + getOrderTypeLabel(cp.current_state.existing_order_type)}
                        callback={doProcessBarn} action="process" extraClasses={"order-now sf-btn-primary"}/>
        </div>}
        {(cp.current_state.existing_order_type && cp.order_number) && <div className="current-order-number">
          <em>{'Currently editing ' + getOrderTypeLabel(cp.current_state.existing_order_type) + ' #' + cp.order_number}</em>
        </div>}
        <div className="support-phone">
          {(settings.company.order_support_phone || cp.associated_dealer.support_phone) &&
            <span className="font-weight-bold">Need Help? Call</span>} {
          <span>{(cp.associated_dealer.support_phone ? cp.associated_dealer.support_phone : settings.company.order_support_phone)}</span>}
        </div>
      </React.Fragment>
    );
  }
}


// Context APP
class ContextMenu extends React.Component {
  constructor(props) {
    super(props);

    this.doAction = this.doAction.bind(this);
    this.stopPropHandler = this.stopPropHandler.bind(this);
    this.handleChange = this.handleChange.bind(this);

    this.state = {current_state: this.props.current_state};
  }

  handleChange(val) {
    this.setState({current_state: window.cp.current_state});
    // force the pricing to update.
    initReactUI();
    // renders the scene if 3d
    renderSingleFrame();
  }

  stopPropHandler(e) {
    e.nativeEvent.stopImmediatePropagation();
  }

  doAction(e) {
    this[e.target.attributes.data_action.value](e);
    closeContextMenu();
    this.stopPropHandler(e);
    this.handleChange(null);
  }

  doRemoveAction(e) {
    destroyOption3d(window.cp.sel_obj);
    // renders the scene if 3d
    renderSingleFrame();
  }

  doCloseAction(e) {
    // nothing needed here
  }

  render() {
    const cs = this.props.current_state;
    if (!window.cp.sel_obj) {
      return null;
    }
    let opt_id = window.cp.sel_obj.userData.option_id;
    let opt_details = window.cp.settings.options[opt_id];
    return (
      <div id="context-menu"
           className="dropdown-menu dropdown-menu-sm"
           onClick={this.stopPropHandler}
           onMouseDown={this.stopPropHandler}
           onTouchStart={this.stopPropHandler}
           onMouseUp={this.stopPropHandler}
           onTouchEnd={this.stopPropHandler}>
        <InfoPopover title={opt_details.label} description={opt_details.description} placement="bottom"/>
        <PrecisionPositioningMenu sel_obj={window.cp.sel_obj} onChange={this.handleChange}/>
        <AlternateOptionSelector current_state={cs} onChange={this.handleChange}/>
        <AttributeOptionsList current_state={cs} onChange={this.handleChange}/>
        <AddonOptionsList current_state={cs} onChange={this.handleChange}/>
        <ButtonGroup>
          <button type="button"
                  className="btn btn-sm w-100 border border-secondary"
                  onClick={this.doAction}
                  data_action="doRemoveAction">Remove
          </button>
          <button type="button"
                  className="btn btn-sm w-100 border border-secondary"
                  onClick={this.doAction}
                  data_action="doCloseAction">Done
          </button>
        </ButtonGroup>
      </div>
    );
  }
}


// Menu that is added to the context popup for 3d options. Allows moving an option using numbers rather than dragging
class PrecisionPositioningMenu extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleTypedChange = this.handleTypedChange.bind(this);
    this.handleOpen = this.handleOpen.bind(this);
    this.handleApply = this.handleApply.bind(this);

    this.move_dir = null;
    this.timer = null;
    this.processMove = this.processMove.bind(this);
    this.stopRepeatTimer = this.stopRepeatTimer.bind(this);

    this.state = {
      open: false,
      sel_obj_uuid: null
    };
  }

  handleOpen(e) {
    this.setState({open: true});
  }

  handleApply(e) {
    // after valid drop, update current state or reset pos
    if (cp.valid_drop_position) {
      this.setState({open: false});
      updateCurrentStateWithCurDragPos();
      cp.doing_precision_move = false;
    } else {
      alert("Not a valid position for this option.")
    }
  }

  handleTypedChange(e) {
    let edit_dir = e.target.dataset.dir;
    let new_dist = e.target.value;
    let distances = calcDimensionDistances();
    let new_x = window.cp.sel_obj_drag_cur.x;
    let new_y = window.cp.sel_obj_drag_cur.y;
    switch (edit_dir) {
      case "left":
        new_x += (new_dist - distances.l_wall);
        break;
      case "right":
        new_x -= (new_dist - distances.r_wall);
        break;
      case "up":
        new_y -= (new_dist - distances.t_wall);
        break;
      case "down":
        new_y += (new_dist - distances.b_wall);
        break;
    }
    doVisOptionUpdateDragPosition(new_x, new_y);
    // this triggers the state change and updates this component
    this.setState({sel_obj: this.props.sel_obj});
  }

  handleChange(e) {
    let new_x = window.cp.sel_obj_drag_cur.x;
    let new_y = window.cp.sel_obj_drag_cur.y;
    switch (this.move_dir) {
      case "left":
        new_x--;
        break;
      case "right":
        new_x++;
        break;
      case "up":
        new_y++;
        break;
      case "down":
        new_y--;
        break;
    }
    doVisOptionUpdateDragPosition(new_x, new_y);
    // this triggers the state change and updates this component
    this.setState({sel_obj: this.props.sel_obj});
  }

  // used to move one click in a direction, this repeats a move using a timer if the arrow buttons are held down.
  processMove(e) {
    if (e) {
      // if(e.type == "keypress" ) {
      //   if(e.which == 32) {
      //     this.handleChange()
      //   }
      // }
      this.move_dir = e.target.dataset.dir;
      this.counter = 0;
    }
    this.handleChange();
    this.counter++;
    // shorten the delay after 5 moves, this speeds up the repeating
    this.timer = setTimeout(this.processMove, ((this.counter <= 5) ? 200 : 70));
  }

  // stops the timer used for the button down repeater
  stopRepeatTimer() {
    this.move_dir = null;
    clearTimeout(this.timer);
  }

  render() {
    if (!this.props.sel_obj) {
      return null;
    }
    // default the move editor to closed if we are selecting a new option
    if (this.state.sel_obj_uuid != this.props.sel_obj.uuid) {
      this.state.sel_obj_uuid = this.props.sel_obj.uuid;
      this.state.open = false;
    }
    let distances = calcDimensionDistances();

    if (this.state.open) {
      return (
        <div className="precision-pos-menu container">
          <div className="row pr1">
            <div className="col-12 c-mid">
              <ClickToEditNumber
                value={distances.t_wall}
                onChange={this.handleTypedChange}
                dir="up"
              />
            </div>
          </div>
          <div className="row pr1">
            <div className="col-12">
              <button className="btn btn-sm border-secondary"
                      type="button"
                      data-dir="up"
                      onPointerDown={this.processMove}
                      onPointerLeave={this.stopRepeatTimer}
                      onPointerUp={this.stopRepeatTimer}>↑
              </button>
            </div>
          </div>
          <div className="row pr2">
            <div className="col-3 c-left">
              <ClickToEditNumber
                value={distances.l_wall}
                onChange={this.handleTypedChange}
                dir="left"
              />
            </div>
            <div className="col-6 c-mid">
              <button className="btn btn-sm border-secondary"
                      type="button"
                      data-dir="left"
                // onKeyPress={this.processMove}
                      onPointerDown={this.processMove}
                      onPointerLeave={this.stopRepeatTimer}
                      onPointerUp={this.stopRepeatTimer}>←
              </button>
              <button
                className="btn btn-sm border-secondary"
                type="button"
                onClick={this.handleApply}
              >Apply
              </button>
              <button className="btn btn-sm border-secondary"
                      type="button"
                      data-dir="right"
                      onPointerDown={this.processMove}
                      onPointerLeave={this.stopRepeatTimer}
                      onPointerUp={this.stopRepeatTimer}>→
              </button>
            </div>
            <div className="col-3 c-right">
              <ClickToEditNumber
                value={distances.r_wall}
                onChange={this.handleTypedChange}
                dir="right"
              />
            </div>
          </div>
          <div className="row pr3">
            <div className="col-12">
              <button className="btn btn-sm border-secondary"
                      type="button"
                      data-dir="down"
                      onPointerDown={this.processMove}
                      onPointerLeave={this.stopRepeatTimer}
                      onPointerUp={this.stopRepeatTimer}>↓
              </button>
            </div>
          </div>
          <div className="row pr3">
            <div className="col-12 c-mid">
              <ClickToEditNumber
                value={distances.b_wall}
                onChange={this.handleTypedChange}
                dir="down"
              />
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <div className="precision-pos-menu container">
          <div className="row pr1">
            <div className="col-12">
              <button
                className="btn btn-sm border-secondary"
                type="button"
                onClick={this.handleOpen}
              >Edit Position
              </button>
            </div>
          </div>
        </div>
      );
    }
  }
}


// shows a number value until clicked, then becomes editable. This component's onChange happens when Blur happens on the actual input.
// Number can be edited until Blur then change we trigger the onChange handler that was passed in.
class ClickToEditNumber extends React.Component {
  constructor(props) {
    super(props);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleClick = this.handleClick.bind(this);
    // this.handleChange = this.handleChange.bind(this);
    this.state = {showInputEle: false};
  }

  handleClick(e) {
    this.setState({showInputEle: true});
    this.render();
  }

  handleBlur(e) {
    e.target.dataset.dir = this.props.dir;
    this.props.onChange(e);
    // updates this component states so it redraws as closed.
    this.setState({showInputEle: false});
  }

  // handleChange(e) {
  //   console.log("CHANGE with value=", e.target.value);
  // }

  // Render a <span> element
  render() {
    return (
      <div className="click-to-edit-wrapper">
        {
          // Use ternary operator to specify text or input element
          this.state.showInputEle ? (
            <input
              type="number"
              defaultValue={this.props.value}
              // onChange={this.handleChange}
              onBlur={this.handleBlur}
              autoFocus
            />
          ) : (
            <div
              className="label"
              onClick={this.handleClick}>
              {this.props.value}"
            </div>
          )
        }
      </div>
    );
  }
}


// Alternate Option Selector
class AlternateOptionSelector extends React.Component {
  constructor(props) {
    super(props);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  handleOptionChange(e) {
    const target_opt = window.cp.sel_obj;
    const wall_name = target_opt.userData.wall_name;
    const cs_opt_index = target_opt.userData.cs_opt_index;
    // use the 'addOption3d' with true param, so it does a replacement and not a new add
    addOption3d(e.target.value, wall_name, cs_opt_index, true, true);
    this.props.onChange(e.target.value);
  }

  getOptionsList() {
    let opt_list = [];
    const sel_opt_id = window.cp.sel_obj.userData.option_id;
    const opt_group_id = window.cp.opt_group_lookup[sel_opt_id];
    const options = window.cp.settings.option_groups[opt_group_id].options;
    for (let i in options) {
      const cur_opt_id = options[i];
      let opt = window.cp.settings.options[cur_opt_id];
      if (opt.discontinued) {
        continue;
      }
      let vis_class = (opt.visible ? "visible" : "hidden");
      let disabled = !opt.enabled;
      let suffix = (opt.item_price_suffix ? opt.item_price_suffix : '');
      let price = formatPrice(opt.item_price, false, ' [', suffix + ']', false);
      let label = window.cp.settings.options[cur_opt_id].label;
      opt_list.push(
        <div key={cur_opt_id} className={vis_class}>
          <input id={cur_opt_id}
                 type="radio"
                 name={opt_group_id}
                 onChange={this.handleOptionChange}
                 value={cur_opt_id}
                 checked={cur_opt_id == sel_opt_id}
                 disabled={disabled}
          />
          <label htmlFor={cur_opt_id}>&nbsp;{label} <span className="price">{price}</span></label>
        </div>
      );
    }
    return opt_list;
  }

  render() {
    if (!window.cp.sel_obj) {
      return null;
    }
    const options_list = this.getOptionsList();

    return (
      <div>{options_list}</div>
    );
  }
}


// Addon Options List
class AddonOptionsList extends React.Component {
  constructor(props) {
    super(props);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  handleOptionChange(value) {
    this.props.onChange(value);
  }

  getGroupsList() {
    let group_list = [];
    const sel_opt_id = window.cp.sel_obj.userData.option_id;
    const addon_groups = window.cp.compatible_addon_groups_lookup[sel_opt_id];
    // for each addon group
    for (let i in addon_groups) {
      let group_id = addon_groups[i];
      let group = window.cp.settings.option_groups[group_id];
      // @TODO this is rough, should check enabled as well. Also should check if visible on this wall. Maybe if enabled or visible are arrays, then check per wall.
      if (!group.visible) {
        continue;
      }
      // get the index of this parent option in the current state array, find this from the opt with mouse focus
      let cs_parent_opt_index = window.cp.sel_obj.userData.cs_opt_index;
      let sel_addon_opt_id = this.props.current_state.vis_options[cs_parent_opt_index].addons[group_id];
      group_list.push(
        <div key={"add_" + group_id} className="addon-group">
          <label htmlFor={group_id} className="group-label">&nbsp;{group.label} <InfoPopover title={group.label}
                                                                                             description={group.description}/></label>
          <div className="addon-body">
            <AddonOptionSelector cur_val={sel_addon_opt_id} group_id={group_id} onChange={this.props.onChange}/>
          </div>
        </div>
      );
    }
    return group_list;
  }

  render() {
    if (!window.cp.sel_obj) {
      return null;
    }
    const groups_list = this.getGroupsList();
    return (
      <div>{groups_list}</div>
    );
  }
}


// Addon Option Selector
class AddonOptionSelector extends React.Component {
  constructor(props) {
    super(props);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  handleOptionChange(e) {
    const target_parent_opt = window.cp.sel_obj;
    const cs_parent_opt_index = target_parent_opt.userData.cs_opt_index;
    addSubOptionToScene('addon', target_parent_opt, cs_parent_opt_index, this.props.group_id, e.target.value, true);
    this.props.onChange(e.target.value);
  }

  getOptionsList() {
    let opt_list = [];
    let opt_group_id = this.props.group_id;
    let group_details = window.cp.settings.option_groups[opt_group_id];
    let options = group_details.options;
    let cur_val = this.props.cur_val;
    let opt_none_id = 'addon_' + opt_group_id + '_none';
    // add a 'none' option to each group
    opt_list.push(
      <div key="none">
        <input id={opt_none_id}
               name={"addgrp_" + this.props.group_id}
               onChange={this.handleOptionChange}
               value="-1"
               checked={cur_val == -1}
               type="radio"/>
        <label htmlFor={opt_none_id}>&nbsp;-None-</label>
      </div>
    );
    // loop all options in group and make radio button for each.
    for (let i in options) {
      const cur_opt_id = options[i];
      let opt_id_name = "addon_" + cur_opt_id;
      let opt_details = window.cp.settings.options[cur_opt_id];
      let price = formatPrice(opt_details.item_price, false, ' [', ']', false);
      opt_list.push(
        <div key={cur_opt_id}>
          <input id={opt_id_name}
                 name={"addgrp_" + this.props.group_id}
                 onChange={this.handleOptionChange}
                 value={cur_opt_id}
                 checked={cur_opt_id == cur_val}
                 type="radio"/>
          <label htmlFor={opt_id_name}>&nbsp;{opt_details.label}<span className="price">{price}</span></label>
        </div>
      );
    }
    return opt_list;
  }

  render() {
    if (!window.cp.sel_obj) {
      return null;
    }
    const options_list = this.getOptionsList();

    return (
      <div>{options_list}</div>
    );
  }
}


// Attribute Options List
class AttributeOptionsList extends React.Component {
  constructor(props) {
    super(props);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  handleOptionChange(value) {
    this.props.onChange(value);
  }

  getGroupsList() {
    let group_list = [];
    const sel_opt_id = window.cp.sel_obj.userData.option_id;
    const attribute_groups = window.cp.compatible_attribute_groups_lookup[sel_opt_id];
    // for each attribute group
    for (let i in attribute_groups) {
      let group_id = attribute_groups[i];
      let group = window.cp.settings.option_groups[group_id];
      // handles hiding this group if conditionally not visible
      let vis_class = (group.visible ? 'visible' : 'hidden');
      // get the index of this parent option in the current state array, find this from the option which has mouse focus
      let cs_parent_opt_index = window.cp.sel_obj.userData.cs_opt_index;
      let sel_attribute_opt_id = this.props.current_state.vis_options[cs_parent_opt_index].attributes[group_id];
      group_list.push(
        <div key={"add_" + group_id} className={"attribute-group " + vis_class}>
          <label htmlFor={group_id} className="group-label">&nbsp;{group.label} <InfoPopover title={group.label}
                                                                                             description={group.description}/></label>
          <div className="attribute-body">
            <AttributeOptionSelector cur_val={sel_attribute_opt_id} group_id={group_id} onChange={this.props.onChange}/>
          </div>
        </div>
      );
    }
    return group_list;
  }

  render() {
    if (!window.cp.sel_obj) {
      return null;
    }
    const groups_list = this.getGroupsList();
    return (
      <div>{groups_list}</div>
    );
  }
}


// Attribute Option Selector
class AttributeOptionSelector extends React.Component {
  constructor(props) {
    super(props);
    this.handleOptionChange = this.handleOptionChange.bind(this);
  }

  handleOptionChange(e) {
    const target_parent_opt = window.cp.sel_obj;
    const cs_parent_opt_index = target_parent_opt.userData.cs_opt_index;
    addSubOptionToScene('attribute', target_parent_opt, cs_parent_opt_index, this.props.group_id, e.target.value, true);
    this.props.onChange(e.target.value);
  }

  getOptionsList() {
    let opt_list = [];
    let opt_group_id = this.props.group_id;
    let group_details = window.cp.settings.option_groups[opt_group_id];
    let options = group_details.options;
    let cur_val = this.props.cur_val;
    if (group_details.optional) {
      let opt_none_id = 'attribute_' + opt_group_id + '_none';
      // add a 'none' option to each group
      opt_list.push(
        <div key="none">
          <input id={opt_none_id}
                 name={"addgrp_" + this.props.group_id}
                 onChange={this.handleOptionChange}
                 value="-1"
                 checked={cur_val == -1}
                 type="radio"/>
          <label htmlFor={opt_none_id}>&nbsp;-None-</label>
        </div>
      );
    }
    // loop all options in group and make radio button for each.
    for (let i in options) {
      const cur_opt_id = options[i];
      let opt_id_name = "attribute_" + cur_opt_id;
      let opt_details = window.cp.settings.options[cur_opt_id]
      let discontinued = (opt_details.hasOwnProperty('discontinued') && opt_details.discontinued);
      let enabled = (!opt_details.hasOwnProperty('enabled') || opt_details.enabled);
      if((!enabled || discontinued) && (cur_opt_id !== cur_val)) {
        continue;
      }
      let price = formatPrice(opt_details.item_price, false, ' [', ']', false);
      opt_list.push(
        <div key={cur_opt_id}>
          <input id={opt_id_name}
                 name={"addgrp_" + this.props.group_id}
                 onChange={this.handleOptionChange}
                 value={cur_opt_id}
                 checked={cur_opt_id === cur_val}
                 type="radio"/>
          <label htmlFor={opt_id_name}>&nbsp;{opt_details.label}<span className="price">{price}</span></label>
        </div>
      );
    }
    return opt_list;
  }

  render() {
    if (!window.cp.sel_obj) {
      return null;
    }
    const options_list = this.getOptionsList();

    return (
      <div>{options_list}</div>
    );
  }
}


/////////// FUNCTIONS //////////////

function initReactUI() {
  const App = document.querySelector('#react-ui');
  ReactDOM.render(<StructureDesignerApp current_state={window.cp.current_state}/>, App);
}


function initContextMenu() {
  const Popup = document.querySelector('#popup-ui');
  ReactDOM.render(<ContextMenu current_state={window.cp.current_state}/>, Popup);
  // force hide the context menu, so it won't be visible to begin with
  $('#context-menu').hide();
}


function initPopovers() {
  // init the info popover icons
  $('.info-popover').popover({container: 'body'});
  $('.popover-dismiss').popover({trigger: 'focus'});
}


function formatPrice(cents, show_if_zero, prefix, suffix, add_spaces) {
  add_spaces = ((add_spaces == undefined) ? true : add_spaces);
  show_if_zero = ((show_if_zero == undefined) ? true : show_if_zero);
  prefix = ((!prefix) ? '' : (prefix + (add_spaces ? ' ' : '')));
  suffix = ((!suffix) ? '' : ((add_spaces ? ' ' : '') + suffix));
  if (show_if_zero || cents != 0) {
    let price = cents / 100;
    let formatted = prefix + '$' + price.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + suffix;
    // move the negative sign out before the dollar sign if the price is negative
    return formatted.replace('$-', '-$');
  }
  return '';
}
